
import axios, { AxiosResponse } from 'axios';
import Vue from 'vue';
import { JhaUserConfig, JhaUserConfigTableData } from './api/jhauserconfig';

export default class PaymentProcessorService extends Vue {
  static getPaymentProcessorRecord(fiid:string): Promise<JhaUserConfig> {
    const response = axios.get(`/api/paymentprocessor/getFi/${fiid}`)
      .then(data => data.data);
    return response;
  }

  static async addPaymentProcessorFi(newFiData:JhaUserConfig) : Promise<void> {
    axios.put('/api/paymentprocessor/addFi/', newFiData);
  }

  static getPaymentProcessorTable(): Promise<JhaUserConfigTableData> {
    const fieldNamesPayload = 'core, fiid';
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = axios.put('/api/paymentprocessor/getFiTable', fieldNamesPayload, { headers })
      .then(data => data.data);
    return response;
  }

  static createEmptyJhaUserConfig(): JhaUserConfig {
    return {
      core: '',
      fiid: '',
      username: '',
      password: '',
      institutionRoutingId: '',
      productMappings: [
      ],
    };
  }
}

